import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useCallback } from "react";
import type { ColumnComponentProperties } from "../../types";

export const StartDateColumn = (properties: ColumnComponentProperties) => {
  const defaultDate = properties.value ? dayjs(properties.value) : null;
  const startTime = properties.value?.split("T")?.[1] || dayjs().format("HH:mm:ss");

  const handleChange = useCallback(
    (date) => {
      properties.updateFixture({
        fixtureId: properties.fixtureId,
        upsertData: {
          startTimeLocal: date ? `${date.format("YYYY-MM-DD")}T${startTime}` : null,
        },
      });
    },
    [properties, startTime],
  );

  if (properties.editMode) {
    return (
      <DatePicker
        disabled={properties.isUpdatePending}
        format="DD/MM/YYYY"
        mode={"date"}
        defaultValue={defaultDate}
        onChange={handleChange}
      />
    );
  }

  return properties.value ? dayjs(properties.value).format("DD/MM/YYYY") : "";
};
